class FontLoader {
    constructor() {
        this.loadedFonts = new Set();
    }

    async loadFont(fontName) {
        if (this.loadedFonts.has(fontName)) {
            return Promise.resolve();
        }

        try {
            // Dynamic import syntax for webpack code splitting
            switch (fontName.toLowerCase()) {
                case "classic":
                    await import(
                        /* webpackChunkName: "font-classic" */ "../../assets/fonts/helvetica.css"
                    );
                    break;
                case "geometric":
                    await import(
                        /* webpackChunkName: "font-geometric" */ "../../assets/fonts/barlow.css"
                    );
                    break;
                case "modern":
                    await import(
                        /* webpackChunkName: "font-modern" */ "../../assets/fonts/avenir.css"
                    );
                    break;
                case "traditional":
                    await import(
                        /* webpackChunkName: "font-traditional" */ "../../assets/fonts/crimsonpro.css"
                    );
                    break;
            }

            this.loadedFonts.add(fontName);
            return this._waitForFontLoad(fontName);
        } catch (error) {
            console.error(`Failed to load font: ${fontName}`, error);
        }
    }

    _waitForFontLoad(fontFamily) {
        // Use FontFaceObserver or a simple timeout to ensure font is loaded
        return document.fonts.ready.then(() => {
            console.log(`Font ${fontFamily} loaded`);
        });
    }

    // Load a subset of fonts for the dropdown preview
    async preloadDropdownFonts() {
        // Load a lightweight version of each font for the dropdown display
        await Promise.all([
            import(
                /* webpackChunkName: "font-classic" */ "../../assets/fonts/helvetica.css"
            ),
            import(
                /* webpackChunkName: "font-modern" */ "../../assets/fonts/avenir.css"
            ),
            import(
                /* webpackChunkName: "font-geometric" */ "../../assets/fonts/barlow.css"
            ),
            import(
                /* webpackChunkName: "font-traditional" */ "../../assets/fonts/crimsonpro.css"
            )
        ]);
    }
}

export default new FontLoader();
